import React from 'react'
import { Typography, Row, Col, Space, Table } from 'antd';
import { Cell, Label, Pie, PieChart } from 'recharts';
import { getRandomBoolean } from '~/Utils/CommonUtils';
import { ColumnsType } from 'antd/es/table';
import { useRef, useState } from 'react';



interface DataType {
    key: string;
    projectList?: string;
    domain?: string;
    startYear?: number;
    timeLeft?: number
    tags?: string[];
    column1?: string;
    column2?: any;
    backgroundColor?: string;
}

const riskData: DataType[] = [
    {
        key: '1',
        projectList: 'Project-1',
        startYear: 2013,
        domain: 'Services',
        timeLeft: 20,
        tags: ['High Risk'],
    },
    {
        key: '2',
        projectList: 'Project-2',
        startYear: 2020,
        domain: 'Services',
        timeLeft: 20,
        tags: ['Medium Risk'],
    },
    {
        key: '3',
        projectList: 'Project-3',
        startYear: 2022,
        domain: 'Energy',
        timeLeft: 20,
        tags: ['Medium Risk'],
    },
];
const columns: ColumnsType<DataType> = [
    {
        title: 'PROJECT LIST',
        dataIndex: 'projectList',
        key: 'name',
        render: (text) =>
            <Typography.Text style={{ color: '#5F5F5F' }}>
                {text}
            </Typography.Text>
    },
    {
        title: 'RISK SCORE CARD',
        key: 'tags',
        dataIndex: 'tags',
        render: (_, { tags }) => (
            <>
                {tags && tags.map((tag) => {
                    let color;
                    let background;
                    if (tag === 'High Risk') {
                        color = '#AB0D82';
                        background = '#AB0D821A'
                    } else {
                        color = '#510DBC'
                        background = '#510DBC1A'
                    }
                    return (
                        <Typography.Text style={{ background: background, borderRadius: 10, padding: 10, margin: 10, color: color }} key={tag}>
                            {tag}
                        </Typography.Text>
                    );
                })}
            </>
        ),
    },
    {
        title: 'DOMAIN',
        dataIndex: 'domain',
        key: 'domain',
        render: (text) =>
            <Typography.Text style={{ color: '#5F5F5F' }}>
                {text}
            </Typography.Text>
    },
    {
        title: 'START YEAR',
        dataIndex: 'startYear',
        key: 'startYear',
        render: (text) =>
            <Typography.Text style={{ color: '#5F5F5F' }}>
                {text}
            </Typography.Text>
    },
    {
        title: 'TIME LEFT (MONTHS)',
        dataIndex: 'timeLeft',
        key: 'timeLeft',
        render: (text) =>
            <Typography.Text style={{ color: '#5F5F5F' }}>
                {text}
            </Typography.Text>
    },

];
const coloredColumns: ColumnsType<DataType> = [
    {
        title: 'ESG Matrix',
        dataIndex: 'column1',
        width: 150,
        key: 'column1',
        render: (text: any, record: any) => {
            return <div style={{ margin: 16 }}> {text}</div>
        }
    },
    {
        title: 'BP',
        dataIndex: 'column2',
        key: 'column2',
        width: 150,
        render: (text: any, record: any) => {
            return <div style={{ background: getRandomBoolean() ? '#AB0D82' : 'transperant', padding: "25px 15px", margin: 10 }}></div>
        }
    },
    {
        title: 'EXXON',
        dataIndex: 'column2',
        key: 'column2',
        width: 150,
        render: (text: any, record: any) => {
            return <div style={{ background: getRandomBoolean() ? '#AB0D82' : 'transperant', padding: "25px 25px", margin: 10 }}></div>
        }
    },
    {
        title: 'SHELL',
        dataIndex: 'column2',
        key: 'column2',
        width: 150,
        render: (text: any, record: any) => {
            return <div style={{ background: getRandomBoolean() ? '#AB0D82' : 'transperant', padding: "25px 15px", margin: 10 }}></div>
        }
    },
    {
        title: 'PETRONAS',
        dataIndex: 'column2',
        key: 'column2',
        width: 150,
        render: (text: any, record: any) => {
            return <div style={{ background: getRandomBoolean() ? '#AB0D82' : 'transperant', padding: "25px 15px", margin: 10 }}></div>
        }
    },
    {
        title: 'TOTAL ENERGIES',
        dataIndex: 'column2',
        width: 150,
        key: 'column2',
        render: (text: any, record: any) => {
            return <div style={{ background: getRandomBoolean() ? '#AB0D82' : 'transperant', padding: "25px 15px", margin: 10 }}></div>
        }
    },
    {
        title: 'A',
        dataIndex: 'column2',
        key: 'column2',
        width: 150,
        render: (text: any, record: any) => {
            return <div style={{ background: getRandomBoolean() ? '#AB0D82' : 'transperant', padding: "25px 15px", margin: 10 }}></div>
        }
    },
    {
        title: 'B',
        dataIndex: 'column2',
        key: 'column2',
        width: 150,
        render: (text: any, record: any) => {
            return <div style={{ background: getRandomBoolean() ? '#AB0D82' : 'transperant', padding: "25px 15px", margin: 10 }}></div>
        }
    },
];
// const data01 = [
//     {
//         "name": "Group A",
//         "value": 400,
//         category: true
//     },
//     {
//         "name": "Group B",
//         "value": 300
//     },

// ];
const generateMockData = () => {
    const data: DataType[] = [];
    const colors = ['red', 'blue', 'green', 'yellow'];
    const text = ['Environmental Warning', 'Governance Warning', 'Social Warning']

    for (let i = 0; i <= 2; i++) {
        const randomBoolean = Math.random() >= 0.5;
        const backgroundColor = randomBoolean ? colors[Math.floor(Math.random() * colors.length)] : '';

        data.push({
            key: text[i],
            column1: text[i],
            column2: randomBoolean,
            backgroundColor,
        });
    }

    return data;
};


export const DetailView = (props: any) => {
    const { item } = props
    const ref = useRef<HTMLDivElement>(null);
    const [dataSource] = useState(generateMockData());
    const colors = ['#098e7e', '#AB0D82', 'green', 'yellow'];

    console.log(item.ESGRating);

    const data01 = [
        { name: 'Rating', value: Number(item.ESGRating) },
        { name: 'Remaining', value: 5 - Number(item.ESGRating) },
    ];
    const data02 = [
        { name: 'Rating', value: Number(item.InvestableRating) },
        { name: 'Remaining', value: 100 - Number(item.InvestableRating) },
    ];
    const calculateDimension = () => {
        if (ref.current) {
            const { width } = ref.current.getBoundingClientRect();
            return width < 300
                ? 275
                : width
                    ? 275
                    : 300;
        } else {
            return 300;
        }
    };
    return (
        <>
            <Row justify='center'>
                <Col lg={20} style={{ margin: '3.5rem 0 0 0' }} offset={2}>
                    <Col style={{ marginTop: 10, marginBottom: 20 }}>
                        <Typography.Text
                            strong
                            className={"textMedium"}
                            style={{ color: "#003087" }}
                        >
                            Capital Market Monitoring
                        </Typography.Text>
                    </Col>
                    <Row>
                        <Col span={12} style={{ textAlign: 'left' }}>
                            <Typography.Text
                                className={"textMedium"}
                                style={{ color: "#003087" }}
                            >
                                Risk Outlook
                            </Typography.Text>                    </Col>
                        <Col span={12} style={{ textAlign: 'right' }}>
                            <Space>
                                <Typography.Text
                                    className={"text"}
                                    style={{ color: "#003087" }}
                                >
                                    Risk Assessment:
                                </Typography.Text>
                                <Typography.Text
                                    className={"text"}
                                    style={{
                                        color: "#FFFFFF",
                                        background: "#098E7E",
                                        padding: "10px 15px",
                                        borderRadius: 8
                                    }}
                                >
                                    Good
                                </Typography.Text>
                            </Space>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 20 }}>
                        {/* <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center'
                        }}
                    > */}


                        <Col lg={8} md={8} >
                            <Typography.Text
                                className={"textItemCenter text"}
                                style={{ color: "#003087" }}
                            >
                                ESG Rating
                            </Typography.Text>
                            <PieChart
                                width={calculateDimension()}
                                height={calculateDimension()}
                            >

                                <Pie
                                    data={data01}
                                    animationDuration={300}
                                    dataKey="value"
                                    innerRadius={calculateDimension() / 4}
                                >
                                    <Label
                                        value={`Rating:`} position="centerBottom" className='label-top' fontSize='15px'
                                        color="#2C333A"
                                        style={{ color: "#2C333A" }}
                                    />
                                    <Label
                                        value={`${item.ESGRating} / 5`}
                                        position="centerTop"
                                        className='label'
                                        color="#098E7E"
                                        style={{ color: "#098E7E" }}
                                    />
                                    {data01.map((item: any, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={colors[index]}
                                        />
                                    ))}
                                </Pie>

                            </PieChart>

                        </Col>
                        <Col lg={8} md={8} >
                            <Typography.Text
                                className={"textItemCenter text"}
                                style={{ color: "#003087" }}
                            >
                                Investable Rating
                            </Typography.Text>
                            <PieChart
                                width={calculateDimension()}
                                height={calculateDimension()}
                            >
                                <Pie
                                    data={data02}
                                    animationDuration={300}
                                    dataKey="value"
                                    innerRadius={calculateDimension() / 4}
                                >
                                    <Label
                                        value={`Rating:`} position="centerBottom" className='label-top' fontSize='15px'
                                        color="#2C333A"
                                        style={{ color: "#2C333A" }}
                                    />
                                    <Label
                                        value={`${item.InvestableRating} / 100`}
                                        position="centerTop"
                                        className='label'
                                        color="#098E7E"
                                        style={{ color: "#098E7E" }}
                                    />
                                    {data02.map((item: any, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={colors[index]}

                                        />
                                    ))}
                                </Pie>

                            </PieChart>

                        </Col>

                        <Col lg={8} md={8} >
                            <Typography.Text
                                className={"textItemCenter text"}
                                style={{ color: "#003087" }}
                            >
                                Risk Rating
                            </Typography.Text>
                            <PieChart
                                width={calculateDimension()}
                                height={calculateDimension()}
                            >
                                <Pie
                                    data={data02}
                                    animationDuration={300}
                                    dataKey="value"
                                    innerRadius={calculateDimension() / 4}
                                >
                                    <Label
                                        value={`Rating:`} position="centerBottom" className='label-top' fontSize='15px'
                                        color="#2C333A"
                                        style={{ color: "#2C333A" }}
                                    />
                                    <Label
                                        value={`${item.InvestableRating} / 100`}
                                        position="centerTop"
                                        className='label'
                                        color="#098E7E"
                                        style={{ color: "#098E7E" }}
                                    />
                                    {data02.map((item: any, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={colors[index]}

                                        />
                                    ))}
                                </Pie>

                            </PieChart>

                        </Col>
                        {/* </div> */}
                    </Row >
                    {/* <Col style={{ marginTop: 10, marginBottom: 40 }}>
                        <Typography.Text className="textMedium" strong style={{ color: "#003087" }}>Projects Exposed to Risk</Typography.Text>
                    </Col>
                    <Table
                        columns={columns}
                        dataSource={riskData}
                        pagination={false}

                    />
                    <Col style={{ marginTop: 40, marginBottom: 20 }}>
                        <Typography.Text
                            strong
                            className={"textMedium"}
                            style={{ color: "#003087" }}
                        >
                            Capital Market Monitoring
                        </Typography.Text>
                    </Col>
                    <Row style={{ marginBottom: 40 }}>
                        <Col span={12} style={{ textAlign: 'left' }}>
                            <Typography.Text
                                className={"textMedium"}
                                style={{ color: "#003087" }}
                            >
                                Non-Green Supplier Outlook
                            </Typography.Text>                    </Col>
                        <Col span={12} style={{ textAlign: 'right' }}>
                            <Space>
                                <Typography.Text
                                    className={"text"}
                                    style={{ color: "#003087" }}
                                >
                                    More Disclosure Required:
                                </Typography.Text>
                                <Typography.Text
                                    className={"text"}
                                    style={{
                                        color: "#FFFFFF",
                                        background: "#AB0D82",
                                        padding: "10px 15px",
                                        borderRadius: 8
                                    }}
                                >
                                    2/6
                                </Typography.Text>
                            </Space>
                        </Col>
                    </Row>
                    <Table
                        columns={coloredColumns}
                        dataSource={dataSource}
                        pagination={false}
                        className="highlighted-row"
                        style={{ marginBottom: 40 }}

                    /> */}
                </Col>
            </Row >
        </>
    )
}